import React from 'react';

export const ptsdLocationDescription = (
  <div>
    <h3 className="vads-u-font-size--h5">Event location</h3>
    <p>Please tell us where this event happened. Be as specific as you can.</p>
  </div>
);
